import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path fill=\"currentColor\" d=\"M459.072 59.584c28.928-26.176 72.96-26.176 101.824 0l411.648 390.912a37.952 37.952 0 0 1-50.816 56.384l-6.592-6.208v408a75.968 75.968 0 0 1-75.904 76.032H618.176v-228.672a53.504 53.504 0 0 0-53.504-53.568H460.672a53.504 53.504 0 0 0-53.504 53.568v228.672H180.928a75.968 75.968 0 0 1-75.968-76.032V505.6c-16.896 15.296-40.832 14.08-54.848-1.536a37.952 37.952 0 0 1 2.688-53.632L459.072 59.648z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol